module.exports = __webpack_public_path__ + "assets/img/Shipping.97cdc710.svg";